import React, { PropsWithChildren, useContext, useMemo } from 'react';

import { Settings, useGetSettings } from 'hooks/useGetSettings';
import LoadingFullscreen from 'components/common/loading/LoadingFullscreen';

const SettingsContext = React.createContext<Settings | undefined>(undefined);

export function SettingsContextProvider({ children }: PropsWithChildren) {
  const { data: settings, isSuccess } = useGetSettings();

  const value = useMemo(() => settings, [settings]);

  return (
    <SettingsContext.Provider value={value}>
      {!isSuccess && (
        <div className="h-screen" data-testid="provider-settings-loading">
          <LoadingFullscreen />
        </div>
      )}
      {isSuccess && <>{children}</>}
    </SettingsContext.Provider>
  );
}

export const useSettingsContext = () => {
  const context = useContext(SettingsContext);
  if (!context) {
    throw new Error('useSettingsContext hook must be used within a SettingsContextProvider');
  }

  return context;
};
